import './spinner-indicator.style.sass';
import template from './spinner-indicator.tpl.pug';

export default {
    selector: 'dbSpinnerIndicator',
    template: template(),
    bindings: {
        color: '<'
    }
};



// WEBPACK FOOTER //
// ./src/common/component/loader/component/spinner-indicator/spinner-indicator.cmpt.js